import React from 'react';
import ReactDOM from 'react-dom';
import Page from 'Common/Page/';
import CodeBlock from 'Common/CodeBlock';

import Head from './index';

class App extends React.Component {
  render() {
    return (
      <Page title='Head'>
        <Head />
        <CodeBlock
          value={`import { Head } from '@politico/interactive-style-elections';

<Head />
        `}
        />
      </Page>
    );
  }
}

export default App;

ReactDOM.render(<App />, document.getElementById('app'));
